export default "__VITE_ASSET__COFUFQEa__"